import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'rsuite';
import ACHSLogo from '../../../images/ACHSLogo.svg';
import { DONT_WANT_TO_BE_REDIRECTED, WANT_TO_BE_REDIRECTED } from './types';
import { resetLoginState } from '../Login/actions';

import styles from './Selection.module.scss';

class Selection extends React.Component {
  goToAV1 = () => {
    this.props.dispatch(resetLoginState());
    this.props.dispatch({
      type: DONT_WANT_TO_BE_REDIRECTED,
    });
  };

  goToAV2 = () => {
    this.props.dispatch({
      type: WANT_TO_BE_REDIRECTED,
    });
  };

  render() {
    return (
      <div id='selectionRoot' className={styles.root}>
        <div id='selection_ACHSLogoContainer' className={styles.ACHSLogoContainer}>
          <img
            id='selection_ACHSLogoDesktop'
            className={styles.ACHSLogoDesktop}
            src={ACHSLogo}
            alt='Logo de ACHS Virtual'
          />
        </div>
        <div id='selectionCard' className={styles.card}>
          <img
            id='selection_ACHSLogoMobile'
            className={styles.ACHSLogoMobile}
            src={ACHSLogo}
            alt='Logo de ACHS Virtual'
          />
          <div id='selection_body' className={styles.selectionBody}>
            <div id='selection_paragraphContainer' className={styles.paragraphContainer}>
              <p
                id='selection_paragraphContainer_greetingsParagraph'
                className={styles.greetingsParagraph}
              >
                ¡Hola{' '}
                <span role='img' aria-label='greeting hand'>
                  👋
                </span>
                !
              </p>
              <h2
                id='selection_paragraphContainer_greetingsTitle'
                className={styles.greetingsTitle}
              >
                Bienvenido a ACHS Virtual
              </h2>
              <p
                id='selection_paragraphContainer_chooseParagraph'
                className={styles.chooseParagraph}
              >
                Selecciona la versión de ACHS Virtual a la que deseas ingresar.
              </p>
            </div>
            <div id='selection_buttonsContainer' className={styles.buttonsContainer}>
              <Button
                id='selection_buttonsContainer_ACHSVirtualV1'
                className={styles.v1Button}
                onClick={this.goToAV1}
              >
                ACHS Virtual
                <span className={styles.highlightText}>actual</span>
              </Button>
              <Button
                id='selection_buttonsContainer_ACHSVirtualV2'
                className={styles.v2Button}
                onClick={this.goToAV2}
              >
                ACHS Virtual
                <span className={styles.highlightText}>nueva versión</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Selection);
